import React from 'react';
import { Link } from 'react-router-dom';

// Renders an entity-hierarchy breadcrumb trail.
// items: [{ label: 'Smith Case', icon: BriefcaseIcon, to: '/cases/abc' }, ...]
// Each item is clickable with an optional icon.
const Breadcrumb = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="flex items-center space-x-4 text-sm text-gray-600 mt-1">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <Link
            key={item.to}
            to={item.to}
            className="text-yellow-600 hover:text-gray-800 flex items-center"
          >
            {Icon && <Icon className="h-4 w-4 mr-1" />}
            {item.label}
          </Link>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
